var map = {
	"./biology.json": [
		"1O3Y",
		34
	],
	"./carousel.json": [
		"g8D0",
		4
	],
	"./chemistry.json": [
		"UmwQ",
		33
	],
	"./computer.json": [
		"dKl5",
		32
	],
	"./deverlopment.json": [
		"g2AZ",
		31
	],
	"./directors.json": [
		"+vtE",
		3
	],
	"./dormStaff.json": [
		"v25T",
		30
	],
	"./engineering.json": [
		"5Ki1",
		29
	],
	"./english.json": [
		"VhML",
		28
	],
	"./health.json": [
		"dRtB",
		27
	],
	"./history.json": [
		"pXXj",
		26
	],
	"./index.json": [
		"Xjoz",
		2
	],
	"./japanse.json": [
		"zEbG",
		25
	],
	"./maths.json": [
		"cBhw",
		24
	],
	"./modal.json": [
		"vzQV",
		1
	],
	"./officers.json": [
		"FgIh",
		23
	],
	"./physics.json": [
		"lyTX",
		22
	],
	"./psychologist.json": [
		"plko",
		21
	],
	"./staff.json": [
		"oaSl",
		0
	],
	"./thai.json": [
		"yHp4",
		20
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "V/bz";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/json/th/staff lazy ^\.\/.*\.json$
// module id = V/bz
// module chunks = 81